import { PropsWithChildren } from 'react';
import { LoanSearchParams } from '../../helpers/loanSearchParams';
import { VerticalType } from '../../types';
import { PersonalLoanFilter } from '.';
import { PortalTo } from '$/components/Portal';

interface WrapperProps {
  wrapperClassName?: string;
  onFinishedEnterFilter: (a: LoanSearchParams) => void;
  vertical?: VerticalType;
  defaultParams: LoanSearchParams;
  onlyListen?: boolean;

  min_loan_amount: number | undefined;
  max_loan_amount: number | undefined;
  min_loan_tenure: number | undefined;
  max_loan_tenure: number | undefined;
}
export const PersonalLoanFilterWrapper = (
  props: PropsWithChildren<WrapperProps>,
) => {
  return (
    <>
      {props.vertical === 'PERSONAL_LOANS' ? (
        <PortalTo rootId="personal-loan-filter">
          <PersonalLoanFilter
            onlyListen={
              !!props.onlyListen && props.vertical === 'PERSONAL_LOANS'
            }
            show={props.vertical === 'PERSONAL_LOANS' && !props.onlyListen}
            onFinished={props.onFinishedEnterFilter}
            defaultParams={props.defaultParams}
            max_loan_amount={props.max_loan_amount}
            max_loan_tenure={props.max_loan_tenure}
            min_loan_amount={props.min_loan_amount}
            min_loan_tenure={props.min_loan_tenure}
          />
        </PortalTo>
      ) : null}
      {props.wrapperClassName ? (
        <div className={props.wrapperClassName}>{props.children}</div>
      ) : (
        props.children
      )}
    </>
  );
};
